import { render } from "./TopicDetails.vue?vue&type=template&id=2427d019"
import script from "./TopicDetails.vue?vue&type=script&lang=js"
export * from "./TopicDetails.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hutch/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__